export interface IFileEditRequest {
    dno: number;
    ano: number;
    ono: number;
    vno: number;
    filename: string;
    container_tag: string;
}
